import * as z from "zod/v4";

export const getProductById = {
  name: "getProductById" as const,
  input: z.object({ productId: z.string() }),
  output: z.object({
    imageSrc: z.string().optional(),
    title: z.string(),
    variants: z.array(z.object({ id: z.string(), available: z.boolean() })),
  }),
};
